// globs.ts
// (c) 2017 EvoluS Srl
// (a) VG

import * as moment from 'moment';

/**
 * Classe di funzioni di uso generale
 * sono tutte statiche
 */
export class Globs {
  static readonly UI_HEIGHT = 24;
  static readonly UI_FONTSIZE = '14px';
  static readonly DAY_MS = 24 * 60 * 60 * 1000;
  // colori non programmabili nel css
  static readonly ERR_BACKGROUND = '#ffdbe1';

  static uuidGen() {
    let d = new Date().getTime();
    const uuid = 'xxxxxxxx-xxxx-4xxx-yxxx-xxxxxxxxxxxx'.replace(/[xy]/g, (c) => {
      const r = (d + Math.random() * 16) % 16 || 0;
      d = Math.floor(d / 16);
      return (c === 'x' ? r : (r & 0x7 || 0x8)).toString(16);
    });
    return uuid;
  }

  static formatMoney(n, cP, dP?, tP?) {
    const c = isNaN(cP = Math.abs(cP)) ? 2 : cP,
      d = dP === undefined ? ',' : dP,
      t = tP === undefined ? '.' : tP,
      s = n < 0 ? '-' : '',
      i = String(parseInt(n = Math.abs(Number(n) || 0).toFixed(c)));
    let j = i.length;
    j = j > 3 ? j % 3 : 0;

    return s + (j ? i.substr(0, j) + t : '') + i.substr(j).replace(/(\d{3})(?=\d)/g, '$1' + t) + (c ? d + Math.abs(n - Number(i)).toFixed(c).slice(2) : '');
  }

  static dataIsoToJs(isoData: string): Date {
    const regexIso8601 = /^(\d{4}-\d{2}-\d{2})(?:[T,\s](\d{2}):(\d{2}):(\d{2})(?:\.(\d{1,})){0,1}){0,1}/;
    if (!isoData) {
      return null;
    }
    const match = isoData.match(regexIso8601);
    if (match !== null) {
      const datadaparsare = match[0].substring(0, 20);
      const a: string[] = datadaparsare.split(/[^0-9]/);
      let ms: Date = null;
      if (a.length === 3) {
        ms = new Date(Number(a[0]), Number(a[1]) - 1, Number(a[2]));
      } else {
        ms = new Date(Number(a[0]), Number(a[1]) - 1, Number(a[2]), Number(a[3]), Number(a[4]), Number(a[5]));
      }
      if (ms.toString() === 'Invalid Date') {
        ms = null;
      }
      // ms.setSeconds(ms.getSeconds()+ms.getTimezoneOffset())
      return ms;
    }
    return null;
  }

  static dataIsoToString(isoData: string): string {
    if (!isoData) {
      return '';
    }
    const yyyy = isoData.substr(0, 4);
    const mm = isoData.substr(5, 2);
    const dd = isoData.substr(8, 2);
    const time = isoData.substr(11, 5);
    return `${dd}/${mm}/${yyyy} ${time}`;
  }

  static dataJsToPg(jsdate: Date): string {
    if (!jsdate) {
      return '';
    }
    if (!(jsdate instanceof Date)) {
      return '';
    }
    const yyyy: number = jsdate.getFullYear();
    const yyyys: string = yyyy.toString();
    const mm: number = jsdate.getMonth() + 1;
    let mms: string = mm.toString();
    if ((mm < 10) && (mm > 0)) {
      mms = '0' + mms;
    }
    const dd = jsdate.getDate();
    let dds: string = dd.toString();
    if ((dd < 10) && (dd > 0)) {
      dds = '0' + dds;
    }
    return `${yyyys}-${mms}-${dds}`;
  }

  static oraJsToPg(jsdate: Date): string {
    const hh: number = jsdate.getHours();
    let hhs: string = hh.toString();
    if ((hh < 10) && (hh >= 0)) {
      hhs = '0' + hhs;
    }
    const mm: number = jsdate.getMinutes();
    let mms: string = mm.toString();
    if ((mm < 10) && (mm >= 0)) {
      mms = '0' + mms;
    }
    const ss: number = jsdate.getSeconds();
    let sss: string = ss.toString();
    if ((ss < 10) && (ss >= 0)) {
      sss = '0' + sss;
    }
    const ms: number = jsdate.getMilliseconds();
    let mss: string = ms.toString();
    while (mss.length < 3) {
      mss = '0' + mss;
    }
    return `${hhs}:${mms}:${sss}.${mss}`;
  }

  static dataOraJsToPg(jsdate: Date): string {
    return this.dataJsToPg(jsdate) + ' ' + this.oraJsToPg(jsdate);
  }

  static dataOggiPg(): string {
    return this.dataJsToPg(new Date());
  }

  static dataOraOggiPg(): string {
    return this.dataOraJsToPg(new Date());
  }

  static dateFormat(date: Date, mask?: string, utc?: string) {
    // Some common format strings
    const masks = {
      default: 'ddd mmm dd yyyy HH:MM:ss',
      shortDate: 'm/d/yy',
      mediumDate: 'mmm d, yyyy',
      longDate: 'mmmm d, yyyy',
      fullDate: 'dddd, mmmm d, yyyy',
      shortTime: 'h:MM TT',
      mediumTime: 'h:MM:ss TT',
      longTime: 'h:MM:ss TT Z',
      isoDate: 'yyyy-mm-dd',
      isoTime: 'HH:MM:ss',
      isoDateTime: 'yyyy-mm-dd\'T\'HH:MM:ss',
      isoUtcDateTime: 'UTC:yyyy-mm-dd\'T\'HH:MM:ss\'Z\''
    };
    // Internationalization strings
    const i18n = {
      dayNames: [
        'Dom', 'Lun', 'Mar', 'Mer', 'Gio', 'Ven', 'Sab',
        'Domenica', 'Lunedì', 'Mertedì', 'Mercoledì', 'Giovedì', 'Venerdì', 'Sabato'
      ],
      monthNames: [
        'Gen', 'Feb', 'Mar', 'Apr', 'Mag', 'Giu', 'Lug', 'Ago', 'Set', 'Ott', 'Nov', 'Dic',
        'Gennaio', 'Febbraio', 'Marzo', 'Aprile', 'Maggio', 'Giugno', 'Luglio', 'Agosto', 'Settembre', 'Ottobre', 'Novembre', 'Dicembre'
      ]
    };
    const token = /d{1,4}|m{1,4}|yy(?:yy)?|([HhMsTt])\1?|[LloSZ]|"[^"]*"|'[^']*'/g;
    const timezone = /\b(?:[PMCEA][SDP]T|(?:Pacific|Mountain|Central|Eastern|Atlantic) (?:Standard|Daylight|Prevailing) Time|(?:GMT|UTC)(?:[-+]\d{4})?)\b/g;
    const timezoneClip = /[^-+\dA-Z]/g;
    const pad = function(val, len?) {
      val = String(val);
      len = len || 2;
      while (val.length < len) {
        val = '0' + val;
      }
      return val;
    };

    // Regexes and supporting functions are cached through closure
    function doFormat(date, mask, utc) {
      // let dF: any = dateFormat;

      // You can't provide utc if you skip other args (use the "UTC:" mask prefix)
      if (arguments.length === 1 && Object.prototype.toString.call(date) === '[object String]' && !/\d/.test(date)) {
        mask = date;
        date = undefined;
      }

      // Passing date through Date applies Date.parse, if necessary
      date = date ? new Date(date) : new Date;
      if (isNaN(date)) {
        throw SyntaxError('data non valida');
      }

      mask = String(masks[mask] || mask || masks.default);

      // Allow setting the utc argument via the mask
      if (mask.slice(0, 4) === 'UTC:') {
        mask = mask.slice(4);
        utc = true;
      }

      const _ = utc ? 'getUTC' : 'get',
        d = date[_ + 'Date'](),
        D = date[_ + 'Day'](),
        m = date[_ + 'Month'](),
        y = date[_ + 'FullYear'](),
        H = date[_ + 'Hours'](),
        M = date[_ + 'Minutes'](),
        s = date[_ + 'Seconds'](),
        L = date[_ + 'Milliseconds'](),
        o = utc ? 0 : date.getTimezoneOffset(),
        flags = {
          d,
          dd: pad(d),
          ddd: i18n.dayNames[D],
          dddd: i18n.dayNames[D + 7],
          m: m + 1,
          mm: pad(m + 1),
          mmm: i18n.monthNames[m],
          mmmm: i18n.monthNames[m + 12],
          yy: String(y).slice(2),
          yyyy: y,
          h: H % 12 || 12,
          hh: pad(H % 12 || 12),
          H,
          HH: pad(H),
          M,
          MM: pad(M),
          s,
          ss: pad(s),
          l: pad(L, 3),
          L: pad(L > 99 ? Math.round(L / 10) : L),
          t: H < 12 ? 'a' : 'p',
          tt: H < 12 ? 'am' : 'pm',
          T: H < 12 ? 'A' : 'P',
          TT: H < 12 ? 'AM' : 'PM',
          Z: utc ? 'UTC' : (String(date).match(timezone) || ['']).pop().replace(timezoneClip, ''),
          o: (o > 0 ? '-' : '+') + pad(Math.floor(Math.abs(o) / 60) * 100 + Math.abs(o) % 60, 4)
          // S:    ["th", "st", "nd", "rd"][d % 10 > 3 ? 0 : (d % 100 - d % 10 !== 10) * d % 10]
        };

      return mask.replace(token, function($0) {
        return $0 in flags ? flags[$0] : $0.slice(1, $0.length - 1);
      });
    }

    return doFormat(date, mask, utc);
  }

  // Ritorna il numero di giorni tra due date
  static calcolaGiorni(data1: string, data2: string): string {
    if (!data1) {
      return '';
    }
    if (!data2) {
      return '';
    }
    const jsdata1 = this.dataIsoToJs(data1);
    const jsdata2 = this.dataIsoToJs(data2);
    const diff = Number(jsdata2) - Number(jsdata1);
    const days = Math.ceil(diff / this.DAY_MS) + 1;
    return (days > 0) ? days.toString() : '';
  }

  // Calcoli sulle settimane fatti con moment
  static aggiungiSettimane(dataini: string, settimane: string): string {
    const ini = moment(dataini);
    const sett = Number(settimane);
    if (!isNaN(sett)) {
      const giorni = sett * 7;
      return ini.add(giorni, 'days').format('YYYY-MM-DD');
    }
    return '';
  }

  static calcolaSettimane(dataini: string, dataend: string): string {
    let result = '';
    if (dataini && dataend) {
      const ini = moment(dataini);
      const end = moment(dataend);
      const diff = Math.round(end.diff(ini, 'days') / 7);
      result = diff.toString();
    }
    return result;
  }

  // Ritorna il numero di settimane di gravidanza
  static calcolaSettimana(data1: string, data2: string): number {
    if (!data1) {
      return null;
    }
    if (!data2) {
      return null;
    }
    const giorni = this.calcolaGiorni(data1, data2);
    const ngiorni = Number(giorni) - 1;
    if (ngiorni !== NaN) {
      return Math.round(ngiorni / 7 + 1);
    } else {
      return null;
    }
  }

  static aggiungiGiorni(data: string, giorni: string): string {
    if (!data) {
      return '';
    }
    const jsdata = Globs.dataIsoToJs(data);
    if (!giorni) {
      return '';
    }
    const ngiorni: number = Number(giorni);
    if (isNaN(ngiorni)) {
      return '';
    }
    jsdata.setDate(jsdata.getDate() + ngiorni - 1);
    return Globs.dataJsToPg(jsdata);
  }

  static aggiungiGiorniNum(data: string, giorni: number): string {
    if (!data) {
      return '';
    }
    const jsdata = Globs.dataIsoToJs(data);
    if (!giorni) {
      return '';
    }
    if (isNaN(giorni)) {
      return '';
    }
    jsdata.setDate(jsdata.getDate() + giorni - 1);
    return Globs.dataJsToPg(jsdata);
  }

  static sottraiGiorni(data: string, giorni: string): string {
    if (!data) {
      return '';
    }
    const jsdata = Globs.dataIsoToJs(data);
    if (!giorni) {
      return '';
    }
    const ngiorni: number = Number(giorni);
    if (isNaN(ngiorni)) {
      return '';
    }
    jsdata.setDate(jsdata.getDate() - ngiorni - 1);
    return Globs.dataJsToPg(jsdata);
  }

  static dammiprimogiornodelmese(): string {
    const date = new Date();
    return this.dataJsToPg(new Date(date.getFullYear(), date.getMonth(), 1));
  }

  static dammiultiomgiornodelmese(): string {
    const date = new Date();
    return this.dataJsToPg(new Date(date.getFullYear(), date.getMonth() + 1, 0));
  }

  static formatData(value: string) {
    const sdate = Globs.dataIsoToString(value);
    return sdate.substr(0, 10);
  }

  static formatOra(value: string) {
    const sdate = Globs.dataIsoToString(value);
    return sdate.substr(12, 5);
  }

  static sortString(a: string, b: string): number {
    if (a > b) {
      return 1;
    } else if (a < b) {
      return -1;
    }
    return 0;
  }

  static sortNumber(a: string, b: string): number {
    const numa: number = Number(a);
    const numb: number = Number(b);
    if (isNaN(numa) || isNaN(numb)) {
      return 0;
    }
    if (numa > numb) {
      return 1;
    } else if (numa < numb) {
      return -1;
    } else {
      return 0;
    }
  }

  static stringToFloat(n: string): number {
    // primo vedere se ci sono virgole e trasformarle in punti
    const str = n.replace(',', '.');
    // conversione da string a number (ritorna NaN se fallisce)
    const float: number = Number(str);
    return float;
  }

  static giorniTrascorsi(datamin: string, datamax: string): number {
    // introdurre date in formato PG / ISO
    if (datamin && datamax) {
      const datemin: Date = this.dataIsoToJs(datamin);
      const datemax: Date = this.dataIsoToJs(datamax);
      let elapsed: number;
      if (datemin && datemax) {
        if (datemin > datemax) {
          elapsed = Number(datemin) - Number(datemax);
        } else {
          elapsed = Number(datemax) - Number(datemin);
        }
      }
      return Math.floor(elapsed / this.DAY_MS);
    }
    return null;
  }

  //#region -- Funzioni per il rendering nelle grid dei diari
  /**
   * Renderizza un testo in colore nero
   * @param value testo da renderizzare
   */
  static renderBlack(value: string) {
    if (!value) {
      value = '';
    }
    return `<div style="color: black">${value}</div>`;
  }

  /**
   * Renderizza una data
   * @param value data da renderizzare in formato ISO
   */
  static renderData(value: string) {
    let str = '';
    if (value) {
      const sdate = Globs.dataIsoToString(value);
      str = sdate.substr(0, 10);
    }
    const html = `<div class="nx-diariData">${str}</div>`;
    return html;
  }

  /**
   * Renderizza l'ora
   * @param value data+ora in formato ISO
   */
  static renderOra(value: string) {
    let str = '';
    if (value) {
      const sdate = Globs.dataIsoToString(value);
      str = sdate.substr(11, 5);
    }
    const html = `<div class="nx-diariData">${str}</div>`;
    return html;
  }

  /**
   * Renderizza data e ora
   * @param value data+ora in formato ISO
   */
  static renderDataOra(value: string) {
    let str = '';
    if (value) {
      const sdate = Globs.dataIsoToString(value);
      str = sdate.substr(0, 16);
    }
    const html = `<div class="nx-diariData">${str}</div>`;
    return html;
  }

  /**
   * Renderizza la clip degli allegati
   * @param value true se esistono allegati
   */
  static renderAllegati(value: boolean): string {
    const html: string = value ? '<div style="height: 16px; width: 16px; margin: 2px 0 0 0;" class="nx-icon-clip"></div>' : '';
    return html;
  }

  /**
   * Renderizza un pulsante
   * @param value true se il pulsante è visibile
   * @param icona classe corrispondente all'icona del pulsante
   */
  static renderButton(value: boolean, icona: string): string {
    const html: string = value ? `<a><div style="height: 16px; width: 16px; margin: 2px 0 0 0;" class="${icona}"></div></a>` : '';
    return html;
  }

  /**
   * Renderizza un'icona
   * @param value true se l'icona è visibile
   * @param icona classe corrispondente all'icona da visualizzare
   */
  static renderIcona(value: boolean, icona: string): string {
    const html: string = value ? `<div style="height: 16px; width: 16px; margin: 2px 0 0 0;" class="${icona}"></div>` : '';
    return html;
  }

  /**
   * Renderizza un valore numerico
   * @param value valore numerico da renderizzare
   * @param decimals numero di decimali fisso
   */
  static renderFloat(value: number, decimals: number) {
    if (value === undefined) {
      return '';
    }
    if (value === null) {
      return '';
    }
    let str = '';
    if (!isNaN(value)) {
      str = value.toFixed(decimals);
      str = str.replace('.', ',');
    }
    const html = `<div class="nx-diariTesto">${str}</div>`;
    return html;
  }

  /**
   * Renderizza un valore numerico in Euro
   * @param value valore numerico da renderizzare
   * @param decimals numero di decimali fisso
   */
  static renderMoney(value: number, decimals: number) {
    if (value === undefined) {
      return '';
    }
    if (value === null) {
      return '';
    }
    let str = '';
    if (!isNaN(value)) {
      str = value.toFixed(decimals);
      str = str.replace('.', ',');
    }
    const html = `<div class="nx-diariTesto">${str}  €</div>`;
    return html;
  }

  /**
   * Renderizza nel diario i codici di esenzione con eventuale esenzione totale di default
   * @param value codice di esenzione
   * @param rec riferimento al contenuto della riga del diario
   * @param ese servizio delle esenzioni per sapere esenzione totale di default ecc..
   */

  static renderMedico(value: string, rec: any, index: number, user: any) {
    // qui ho il codguid dell'utente e devo mostrare l'intestazione...
    const codguid = rec.utente;
    const appo = user.filter(user => user.val === codguid);
    let html = `<div class="nx-diariTesto"></div>`;
    if (appo.length > 0) {
      html = `<div class="nx-diariTesto">${appo[0].disp}</div>`;
    }
    return html;
  }

  /**
   * Prepara lo script html per le icone dei diari
   * @param rec il record del diario
   * @param iconeLeft true se si renderizzano le icone a sinistra del testo
   */
  static renderIcone(rec: any, iconeLeft: boolean): string {
    const tooltipText = [];
    let iconHtml = '';
    const icons = [];
    if (rec && rec.drin) {
      icons.push('nx-icon-importante');
      tooltipText.push('Importante');
    }
    if (rec && rec.priv) {
      icons.push('nx-icon-riservata');
      tooltipText.push('Riservato');
    }
    if (rec && rec.suggerita) {
      icons.push('nx-icon-suggerita');
      tooltipText.push('Suggerito');
    }
    if (rec && rec.nonsost) {
      icons.push('nx-icon-sicvolo');
      tooltipText.push('Non sostituibile');
    }
    if (rec && rec.isprivato) {
      icons.push('nx-icon-ssnko');
      tooltipText.push('Ricettario privato');
    }
    if (rec && rec.multiprescrizione) {
      icons.push('nx-icon-multi');
      tooltipText.push('Multiprescrizione');
    }
    if (rec && rec.cronica) {
      icons.push('nx-icon-cronica');
      tooltipText.push('Terapia continuativa');
    }
    if (rec && rec.flaggen) {
      icons.push('nx-icon-ricoveroon');
      tooltipText.push('Ricovero');
    }
    if (rec && rec.pternonvalido) {
      icons.push('nx-icon-pianoterscad');
      tooltipText.push('Piano terapeutico scaduto o mancante');
    }
    if (rec && rec.intolleranza) {
      icons.push('nx-icon-spiastop');
      tooltipText.push('Paziente intollerante al farmaco');
    }
    // if (rec && rec.disattivata) icons.push('nx-icon-spiastop')
    let icoMargin = 'margin-left: 4px;';
    const tooltip = 'nx-tooltip-container';
    if (iconeLeft) {
      icoMargin = 'margin-right: 4px;';
    }
    if (icons && icons.length) {
      icons.forEach((item, index) => {
        const icoTooltip = `<span class="nx-tooltip">${tooltipText[index]}</span>`;
        iconHtml = iconHtml + `<span style="height: 16px; width: 16px; float: left; ${icoMargin}" class="${item} ${tooltip}">${icoTooltip}</span>`;
      });
    }
    return iconHtml;
  }

  /**
   * Renderizza il testo principale di un diario
   * Le icone standard vengono renderizzate in automatico, a desta o a sinistra del testo
   * Il testo delle note (testoblob) viene renderizzato sotto il testo standard
   * @param testo testo da renderizzare
   * @param rec riferimento al contenuto della riga del diario
   * @param riga2 testo aggiuntivo eventuale da renderizzare su seconda riga
   * @param iconeLeft true se devo renderizzare le icone a sinistra del testo
   */
  static renderTestoConIcone(testo: string, rec: any, riga2?: string, iconeLeft?: boolean) {
    let iconRiga1 = this.renderIcone(rec, iconeLeft);
    let iconRiga2 = iconRiga1;
    const txt = testo ? testo : '';
    let html = '';
    if (riga2) {
      iconRiga1 = '';
    } else {
      iconRiga2 = '';
    }
    if (iconeLeft) {
      html = `<div class="nx-diariTesto">${iconRiga1}<span style="float: left; margin-left: 6px;">${txt}</span></div>`;
    } else {
      html = `<div class="nx-diariTesto"><span style="float: left; margin-right: 6px;">${txt}</span>${iconRiga1}</div>`;
    }
    if (riga2 !== undefined) {
      if (riga2) {
        if (iconeLeft) {
          html = `${html}<div class="nx-diariTesto">${iconRiga2}<span style="float: left; margin-left: 6px;">${riga2}</span></div>`;
        } else {
          html = `${html}<div class="nx-diariTesto"><span style="float: left; margin-right: 6px;">${riga2}</span>${iconRiga2}</div>`;
        }
      } else {
        html = `${html}<br>`;
      }
    }
    if (rec && rec.testoblob) {
      html = html + `<div style="color: blue">${rec.testoblob}</div>`;
    }
    return html;
  }

  /**
   * Renderizza il testo principale di un diario (versione semplificata senza icone)
   * @param testo testo da renderizzare
   * @param riga2 seconda riga di testo opzionale da renderizzare
   * @param testoblob testo delle note da renderizzare sotto il testo standard
   */
  static renderTesto(testo: string, riga2?: string, testoblob?: string) {
    const txt = testo ? testo : '';
    let html = `<div class="nx-diariTesto">${txt}</div>`;
    if (riga2) {
      html = `${html}<br><div class="nx-diariTesto" style="float: left">${riga2}</div>`;
    }
    if (testoblob) {
      html = html + `<br><div style="color: blue">${testoblob}</div>`;
    }
    return html;
  }

  /**
   * Stabilisce il colore di default di una riga in base ai flag attivati
   * @param index indice della riga nella grid (0 la prima)
   * @param row contenuto della riga da renderizzare
   */
  static rowColor(index, row): string {
    // l'ordine conta! Il primo flag trovato dà colore a tutta la riga
    if (row.priv === true) {
      return 'color: grey';
    }
    if (row.drin === true) {
      return 'color: red';
    }
    if ((row.cronica === true) || (row.periodico)) {
      return 'color: #C11CD1';
    }
    if (row.suggerita === true) {
      return 'color: #F39C12';
    }
    if (row.stato === 'in uso') {
      return 'color: deepskyblue';
    } // questo è per il ricettario/NRE in uso
    return '';
  }

  /**
   * Stabilisce il colore di default di una cell in base ai flag attivati
   * @param value testo della cell
   * @param row contenuto della riga da renderizzare
   * @param index indice della riga nella grid (0 la prima)
   */
  static cellColor(value, row, index): string {
    // l'ordine conta! Il primo flag trovato dà colore a tutta la riga
    if (row.priv === true) {
      return 'color: grey';
    }
    if (row.drin === true) {
      return 'color: red';
    }
    if ((row.cronica === true) || (row.periodico)) {
      return 'color: #C11CD1';
    }
    if (row.suggerita === true) {
      return 'color: #F39C12';
    }
    if (row.stato === 'in uso') {
      return 'color: deepskyblue';
    } // questo è per il ricettario/NRE in uso
    return '';
  }

  static renderBoolean(v: string, t: any, i: number) {
    let val = '';
    if (v) {
      val = '<svg xml:space="preserve" focusable="false" version="1.1" viewBox="0 0 24 24"><path d="M4.1,12.7 9,17.6 20.3,6.3" fill="none" stroke="black" stroke-width="4"></path></svg>';
    }

    const html = `
		<span class="nx-checkbox inputbox" style="width: 16px; height: 16px;">
			<span class="checkbox-inner">${val}
			</span>
		</span>
	`;
    return html;
  }

  //#endregion
}






// WEBPACK FOOTER //
// ./src/app/globs.ts